import React, { Fragment, useEffect } from "react";
import Backbar from "~/pages/NetworkProviders/BackBar";

import security from "~/services/security";


const Adgem = ()=> {

  const currentUser = security.currentUserValue;
  const appId       = 24983;

  useEffect(()=> {
    document.body.style.overflow = "hidden";
  }, []);

  return (
    <Fragment>
      <Backbar path="/offers" showLogo={true} />

      <iframe
        width="100%"
        frameBorder="0"
        style={{ height: "92vh" }}
        src = {`https://api.adgem.com/v1/wall?appid=${appId}&playerid=${currentUser.id}`}
      >Your browser doesn’t support iframes</iframe>
    </Fragment>
  );
};

export default Adgem;
